<template>
  <div class="postrank">
     <div class="form">
      <input type="text" class="input" v-model="registerNumber" placeholder="请输入注册编码">
       <input type="text" class="input" v-model="positionCode" placeholder="请输入职位代码">
      <van-button round type="info" @click="handleSumbit">立即查询</van-button>
     </div>
     <div v-if="total > 0" style="margin-bottom: 10px">
       <van-sticky>
    <div style="background-color: #fff;padding: 10px 16px; border-bottom: 1px solid #ebedf0">
        <van-row type="flex" style=" text-align: center;"> 
        <van-col span="3">排名</van-col>
        <van-col span="6">注册编码</van-col>
        <van-col span="5">笔试成绩</van-col>
        <van-col span="5">面试成绩</van-col>
        <van-col span="5">总成绩</van-col>
      </van-row>
      </div>
</van-sticky>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
      <van-cell v-for="(item,index) in tableData" :key="index">
     <van-row type="flex" style=" text-align: center;">
        <van-col span="3">{{ index + 1 }}</van-col>
        <van-col span="6">{{ item.registerNumber }}</van-col>
        <van-col span="5">{{ item.paperScore}}</van-col>
        <van-col span="5">{{ item.interviewScore}}</van-col>
        <van-col span="5">{{ item.totalScore}}</van-col>
      </van-row>
      </van-cell>
      </van-list>
     </div>
    <p style="color: #FF3229; font-size:0.75rem;margin: 0 .9375rem">华智公考提示广大考生，请报考前仔细阅读对应职位招录要求或联系招录单位确认，本职位检索系统提供内容仅供参考！</p>
  </div>
</template>

<script>
import { api_position } from '@/common/Request.js'
import { Toast } from "vant";
export default {
    data() {
        return {
            tableData: [],
            registerNumber: '',
            positionCode: '',
            zyear: 2023,
            pageNo: 1,
            pageSize: 10,
            total: 0,
           loading: true,
           finished: false,
        }
    },
   methods: {
       handleSumbit() {
          if(this.deep()) {
             const params = Object.assign({}, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        registerNumber: this.registerNumber,
        positionCode: this.positionCode,
        zyear: this.zyear
      })
      api_position.rankList(params).then(res => {
       if (res.data.records.length === 0) {
          this.tableData = [];
          this.finished = true;
        }
       this.tableData=[...this.tableData,...res.data.records]
        this.total = res.data.total;
        this.loading = false;
        if (this.tableData.length >= res.data.total) {
          this.finished = true;
        }
        if (res.data.total === 0) {
          Toast('暂时未搜到相关信息')
        }
      })
          }
     },
      onLoad() {
         this.pageNo++
       this.handleSumbit()
      },
       // 判断用户是否登录
    deep() {
       if (localStorage.getItem("huazhizwktoken")) {
        const newTime = Number(new Date());
        const token = JSON.parse(localStorage.getItem("huazhizwktoken"))[0]
          .token;
        const oldTime = token + 3600 * 1000 * 24 * 60;
        if (newTime < oldTime) {
          this.flag = true
        }
      }else {
        this.show = true;
      }
      return this.flag
    }
   }
}
</script>

<style lang="scss" scoped>
  .postrank {
    .form {
      padding: 1.25rem /* 40/32 */ 3.09375rem /* 99/32 */;
      background-color: #fff;
      .input {
        width: 17.25rem /* 552/32 */;
        height: 2.5625rem /* 82/32 */;    
        border: 1px solid #999999;
        border-radius: .125rem /* 4/32 */;
        margin-bottom: 1.25rem /* 40/32 */;
      }
      ::v-deep .van-button {
        width: 17.1875rem /* 550/32 */;
        height: 2.5rem /* 80/32 */;
      }
    }
  }
</style>